import { useEffect, useRef, useState } from "react";
import { blogPosts } from "@/mocks/albertData";

export default function Blog() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="blog" className="py-24 bg-[#06060a]" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className={`flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="text-[#c9a84c] text-sm tracking-widest uppercase font-medium mb-4">Conocimiento espiritual</p>
            <h2 className="font-serif text-4xl md:text-5xl text-white font-bold">
              Sabiduría <span className="text-[#c9a84c]">Espiritual</span>
            </h2>
            <p className="text-white/60 text-base mt-3 max-w-lg">
              Artículos, guías y reflexiones para tu crecimiento espiritual y personal.
            </p>
          </div>
          <div className="flex-shrink-0">
            <span className="px-4 py-2 border border-[#c9a84c]/30 text-[#c9a84c] text-xs rounded-full whitespace-nowrap">
              Actualizado Semanalmente
            </span>
          </div>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {blogPosts.map((post, i) => (
            <article
              key={post.id}
              className={`group bg-[#0f0f1a] border border-white/10 rounded-2xl overflow-hidden hover:border-[#c9a84c]/40 transition-all duration-500 cursor-pointer ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <span className="text-[#c9a84c] text-xs font-semibold tracking-wide uppercase">{post.category}</span>
                <h3 className="text-white font-semibold text-sm mt-2 mb-3 leading-snug line-clamp-2 group-hover:text-[#c9a84c] transition-colors duration-300">
                  {post.title}
                </h3>
                <p className="text-white/50 text-xs leading-relaxed line-clamp-2 mb-4">{post.excerpt}</p>

                <div className="flex items-center justify-between">
                  <span className="text-white/40 text-xs">{post.date}</span>
                  <div className="flex items-center gap-1 text-white/40 text-xs">
                    <i className="ri-time-line"></i>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className={`text-center mt-10 transition-all duration-1000 delay-500 ${visible ? "opacity-100" : "opacity-0"}`}>
          <button className="px-8 py-3 border border-[#c9a84c]/50 text-[#c9a84c] text-sm font-semibold rounded-full hover:bg-[#c9a84c] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap">
            Ver todos los artículos
          </button>
        </div>
      </div>
    </section>
  );
}
